const LIVELLI_IDRO_URL = `https://api.arpa.veneto.it/REST/v1/meteo_meteogrammilivello?coordcd=20005&orario=0&rete=MGRAMMI`;

/**
 * Fetch livelli idro stations
 *
 * @returns {Promise<Array>} Stations data
 */
export const getLivelliIdroData = () =>
  fetch(LIVELLI_IDRO_URL)
    .then(res => res.json())
    .then(result => result?.data || []);

/**
 * Get the sorted list of field names of stations data (same as DataMap)
 *
 * @param {Array} items Stations data
 * @returns {Array} Field names
 */
export const getLivelliIdroFields = items => (items?.length ? Object.keys(items[0]) : []).sort();
